<template>
    <div>
        <div v-if="getStartConsole > 0">{{prepareConsole()}}</div> 
        <small>{{vplProcessInfo}}</small>
        <div>          
            <v-btn-toggle v-model="tabIndex" mandatory>
                <v-btn x-small dense>Console</v-btn>
                <v-btn x-small dense>Compiler info</v-btn>
                <v-btn x-small dense>Exec-info</v-btn>
                <v-btn x-small dense>Test results</v-btn>
            </v-btn-toggle> 
            <div v-if="tabIndex == 0" class="d-flex flex-row">
                <v-textarea 
                    ref = "tta"
                    rows="8" 
                    v-model="terminal" 
                    background-color="#FFFFFF"
                    v-on:keydown="inputKeydown"
                ></v-textarea>

                <div class="d-flex flex-column py-2 ml-2">
                    <v-icon @click="killProcess()" color="red" title="Kill process" style="position: relative; top: 4px; right: 4px; z-index: 2;">stop</v-icon>     
                    <v-icon @click="clearConsole()" color="green" title="Clear console" style="position: relative; top: 4px; right: 4px; z-index: 2;">data_thresholding</v-icon>  
                </div>
            </div>
            <v-textarea v-if="tabIndex == 1"
                rows="5" 
                v-model="vplCompilerInfo" 
                readonly
                background-color="#EEEEEE"
            ></v-textarea>
            <v-textarea v-if="tabIndex == 2"
                rows="5" 
                v-model="vplExecutionInfo" 
                readonly
                background-color="#EEEEEE"
            ></v-textarea>
            <v-card v-if="tabIndex == 3" background-color="#CDCDCD">
                <v-card-text v-if="testResults.length>0">
                    <div v-for="(xtest, index) in testResults" :key="index">
                        <!-- <p v-if="xtest.test_result != 'OK'">  -->
                        <p v-if="xtest.test_result != 'xOK'" @click="collapseClick(index)">
                            <v-icon color="green" v-if="xtest.test_result == 'OK'">check_circle_outline</v-icon>
                            <v-icon color="red" v-else>error</v-icon>
                            {{xtest.test_result}} {{xtest.test_name}}
                            <v-icon color="red" v-if="xtest.test_result != 'OK'">keyboard_arrow_down</v-icon>
                            <v-icon color="green" v-else>keyboard_arrow_down</v-icon>
                        </p>
                        <v-card v-if="testResultsCollapse.includes(index)" >
                            <v-card-text>
                                <h3>Input:</h3>
                                <p v-html="'<pre>'+xtest.input+'</pre>'"></p>
                                <h3>Expected output:</h3>
                                <p v-html="'<pre>'+xtest.expected+'</pre>'"></p>
                                <h3>Your output:</h3>
                                <p v-html="'<pre>'+xtest.output+'</pre>'"></p>
                            </v-card-text>
                        </v-card>
                    </div>
                </v-card-text>
            </v-card>
        </div>
    </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import * as misc from '../../assets/misc.js'
  import configData from '../../config.js'
  import axios from '../../axios-auth.js'
   
    export default {
        data() {
            return {
                myExecutionSocket: null,
                terminal: '',
                terminalLocked: 0,
                monitoringSocket : null,
                myTickets : null,
                tabIndex : 0,
                vplCompilerInfo: '',
                vplExecutionInfo: '',
                vplProcessInfo: '',
                grade: 0,
                testResults: [],
                testResultsCollapse: []
            }
        },    
        computed: 
            mapGetters([
                'getStartConsole'              
            ]),
        destroyed() {
           this.closeSockets()  
        },
        props : {
            terminalIndex: {type: Number, default: 1},
            activity_type: {type: String},
            dcontent: {type: Object},
            taskIndex : {type: Number},
            startTime: {type: Date},
        },        
        methods: {      
            prepareConsole() {
                if (this.monitoringSocket != null) { // process is running
                    this.$store.commit('setStartConsole',0)
                    return 
                }
                if (this.getStartConsole != this.terminalIndex) return // first or second console
                this.$store.commit('setStartConsole',0)
                this.myTickets = this.$store.getters.getSocketTickets
                this.readVPLProcess(this.myTickets)
                this.tabIndex = 0
                this.vplCompilerInfo = ''
                this.vplExecutionInfo = ''
                this.testResults = []
                this.grade = 0
            },
            readVPLProcess(tickets) {
                let monitoringTarget = configData.jailSocketConnection + tickets.monitorticket+'/monitor'
                let executionTarget = configData.jailRunSocketConnection + tickets.executionticket+'/execute'

                this.ProcessInfo('awaiting connection... ')

                this.monitoringSocket = new WebSocket(monitoringTarget)
                  this.monitoringSocket.onopen = () => { this.ProcessInfo("connected... ") }
                  this.monitoringSocket.onmessage = ({data}) => {
                      if (data.substring(data.length - 3) == 'seg') data = data.substring(0, data.length - 2) + '.'
                      this.ProcessInfo(data)
                      if (data == 'run:terminal') {
                          this.processExecutionSocket(executionTarget)
                      }
                      if (data == 'retrieve:') { // compilation successfull, start running
                            this.getResult()
                        }
                        if (data == 'close:') { 
                            this.closeSockets()
                        }
                        if (data.substring(0,12) == 'compilation:') { // error in compilation
                            if (data.substring(12).length > 0) {
                                this.addToTerminal(data.substring(12))
                            }
                        }
                    }
                  this.monitoringSocket.onerror = ({data}) => { this.$store.commit('setFeedback', data)  }                
            },
            processExecutionSocket(_executionSocket) {  
                // set cursor
                this.$refs.tta.focus()         
                const textarea = this.$refs.tta.$refs.input       
                // textarea.scrollTop = textarea.scrollHeight          
                this.$nextTick().then(() => { 
                    textarea.selectionStart = this.terminalLocked; textarea.selectionEnd = this.terminalLocked
                })
                

                // open execution socket
                this.myExecutionSocket = new WebSocket(_executionSocket)
                this.terminalLocked = this.terminal.length
                    this.myExecutionSocket.onopen = () => { this.ProcessInfo("execution connected... ") }
                    this.myExecutionSocket.onerror = ({xdata}) => { 
                        this.processInfo("error execution..." + xdata)
                        this.getResult()
                    }
                    this.myExecutionSocket.onmessage = ({data}) => { this.writeServerData(data) }
                    this.myExecutionSocket.onclose = () => {};                    
            },
            writeServerData(_socketData) {              
              this.terminal += misc.hardReplace(_socketData,'\r','')
              this.terminalLocked = this.terminal.length
              if (this.dcontent.task_type_id && _socketData == "sqlite> ") this.killProcess(true) // stop sqlite on server
            },
            sendData() {
              const x = this.terminal.substring(this.terminalLocked) + '\n' 
              this.terminal = this.terminal.substring(0, this.terminalLocked)
              this.myExecutionSocket.send(x)
            },
            killProcess(_silent) {
                if (this.monitoringSocket == null) return
                let data = {
                    adminticket: this.myTickets.adminticket
                }
                axios.post('/vpl-stop', data, this.$store.getters.getAxiosConfig )
                .then(() => {
                    if (!_silent) this.addToTerminal('\n----- interrupted by user -----\n')
                    this.finishProcess()
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                    this.finishProcess()
                })
            },
            addToTerminal(_data) {
                this.terminal += _data
                this.terminalLocked = this.terminal.length
            },
            clearConsole() {
                this.terminal = ''
                this.terminalLocked = 0
            },
            getResult() {
                let d = { 
                    adminticket: this.myTickets.adminticket, 
                    task_type_id: this.dcontent.task_type_id,
                    tests_description: true, // return list of tests    
                    task_id: this.dcontent.task_id,
                    activity_type: this.activity_type,
                    time_length: Math.floor((new Date() - this.startTime)/1000 + 0.5)
                }
                this.ProcessInfo('reading result')
                axios.post('/vpl-get-result33', d, this.$store.getters.getAxiosConfig )
                    .then((res) => {
                        this.vplCompilerInfo = res.data.compilation
                        this.vplExecutionInfo = res.data.execution
                        this.ProcessInfo('')
                        if (this.vplExecutionInfo != null && this.vplExecutionInfo.length > 1) {
                            this.tabIndex = 2
                            let pos = res.data.execution.indexOf('Grade :=>>')
                            if (pos>-1) {
                                this.grade = parseInt(res.data.execution.substring(pos+10).trim())
                                this.finishProcess()
                            }
                            this.prepareUserTestsView(res.data.execution)
                            this.prepareResults()
                        }
                        if (this.vplCompilerInfo != null && this.vplCompilerInfo.length > 1) {
                            this.tabIndex = 1
                            this.prepareResults()
                        }
                    })
                    .catch(error => {
                        this.$store.commit('setFeedback', error)
                        this.finishProcess()
                    })
            },
            prepareResults() {
                this.$store.commit('setTransferAnswer',{index: this.taskIndex, rating: this.grade})
                this.$store.commit('setWaitingForResult',false) // data was delivered
                this.$store.commit('setCheckRatingEvent',true)
            },
            prepareUserTestsView(_data) {
                if (this.dcontent.task_type_id == 8) this.ProcessTestResults8(_data)
                if (this.dcontent.task_type_id == 9) {
                    if (this.$store.getters.getEditorType == 'text/x-java') // and java
                        this.ProcessTestResults9(_data)
                        // python!!!!
                    }    
                this.tabIndex = 3        
            },    
            ProcessInfo(_data){
                this.vplProcessInfo = _data
                // console.log(_data)
                this.$store.commit('setVplProcessInfo', _data)
            },
            closeSockets() {
                this.ProcessInfo('')
                if (this.monitoringSocket) {
                    this.monitoringSocket.close()
                    this.monitoringSocket = null
                }
                if (this.myExecutionSocket) {
                    this.myExecutionSocket.close()
                    this.myExecutionSocket = null
                }
                this.addToTerminal('----- done ----- \n')
                this.finishProcess()
            },
            finishProcess() {
                const _data = {
                    terminalIndex : this.terminalIndex,
                    grade: this.grade
                }
                this.ProcessInfo('')
                this.$store.commit('setConsoleGrade',_data)
                this.$store.commit('setWaitingForResult',false) 
            },
            inputKeydown(e) {
                if (e.keyCode == 13) {e.preventDefault(); this.sendData()}
                if (e.keyCode == 39 || e.keyCode == 37) return
                if (e.keyCode < 47 && e.keyCode != 8 && e.keyCode != 32) {
                    e.preventDefault()
                    return
                }
                const textarea = this.$refs.tta.$refs.input
                let pos = textarea.selectionStart
                if (pos < this.terminalLocked) {
                    e.preventDefault()
                    return
                }
                if (e.keyCode == 8) {
                    e.preventDefault()
                    if (pos == this.terminalLocked) return
                    this.terminal = this.terminal.substring(0, pos-1) + this.terminal.substring(pos)                    
                    this.$nextTick().then(() => { textarea.selectionStart = pos-1; textarea.selectionEnd = pos-1})
                    return
                }
            },
        collapseClick(index) {
            const i = this.testResultsCollapse.indexOf(index)
            if ( i > -1) {
                this.testResultsCollapse.splice(i,1)
            } else {
                this.testResultsCollapse.push(index)
            }
        },
        ProcessTestResults9(data) {
            this.testResults = [];

            const gradeMatch = data.match(/Grade\s*:=>>\s*(\d+)/);
            this.grade = gradeMatch ? parseInt(gradeMatch[1]) : null;
            if (gradeMatch) data = data.replace(/Grade\s*:=>>\s*\d+/, '');

            const tests = data.split(/!--- Test:/).slice(1);

            for (const testBlock of tests) {
                const name_end = testBlock.indexOf('\n');
                const testName = testBlock.substring(0, name_end).trim();
                const content = testBlock.substring(name_end).trim();

                const entries = content.split(/!--- input values:/).slice(1);
                let no = 1;

                for (const entry of entries) {
                    const result_start = entry.indexOf('!--- result:');
                    const output_start = entry.indexOf('!--- program output:');
                    const expected_start = entry.indexOf('!--- expected output:');
                    const result_end = result_start !== -1 ? entry.indexOf('\n', result_start) : -1;

                    const markers = [result_start, output_start, expected_start]
                        .filter(i => i !== -1)
                        .sort((a, b) => a - b);
                    const next_marker = markers.length > 0 ? markers[0] : entry.length;

                    const input = entry.substring(0, next_marker).trim();
                    const result = result_start !== -1 ? entry.substring(result_start + 13, result_end).trim() : '';

                    let output = '', expected = '';
                    if (output_start !== -1 && expected_start !== -1) {
                        const output_end = expected_start;
                        output = entry.substring(output_start + 22, output_end).trim();
                        const expected_end = entry.indexOf('!---', expected_start + 1);
                        expected = entry.substring(expected_start + 23, expected_end === -1 ? entry.length : expected_end).trim();
                    }

                    this.testResults.push({
                        test_name: `(${no}) ${testName}`,
                        test_result: result,
                        input,
                        output,
                        expected
                    });

                    no++;
                }
            }
        },
        ProcessTestResults8(data) {
            this.testResults = []
            var xd = data.substring(0,data.indexOf("<|--"))
            while (xd.indexOf(': ')>-1) {
                this.testResults.push( {
                    test_name: xd.substring(xd.indexOf(': ')+2, xd.indexOf('\n')),
                    test_result: '-OK',
                    input: '',
                    output: '',
                    expected: ''
                })
                xd = xd.substring(xd.indexOf('\n')+1)
            } 
//            var onebad = -1

            if (data.indexOf('<|--\n-Failed tests')>-1) {
                const ft = data.indexOf('<|--\n-Failed tests')
                const eft = data.indexOf('--|>', ft)
                xd = data.substring(ft, eft)
                const edt = data.indexOf('--|>', eft+1)
                var xxd = data.substring(eft+4, edt+4)
                for(let i = 0; i < this.testResults.length; i++) {
                    const name = 'Test '+(i+1)+': '+ this.testResults[i].test_name
                    if (xd.indexOf(name) > -1 ) {
                        // we have bad test
                        this.testResults[i].test_result = 'failed'
                        // find --- Input
                        var n1pos = xxd.indexOf('\n',xxd.indexOf('--- Input',xxd.indexOf('-' + name)))
                        // n1pos = xxd.indexOf('\n',n1pos+1)
                        var n2pos = xxd.indexOf('\n --- Program output',n1pos+1)
                        // 
                        this.testResults[i].input = this.delChars(xxd.substring(n1pos+1,n2pos),'>','\n')
                        // find --- Program output                        
                        n2pos = xxd.indexOf('\n',n2pos+1)
                        n1pos = xxd.indexOf('\n --- Expected output',n2pos+1)
                        // 
                        this.testResults[i].output = this.delChars(xxd.substring(n2pos+1,n1pos),'>','\n')
                        // find --- Expected output
                        n1pos = xxd.indexOf('\n',n1pos+1)
                        n2pos = xxd.indexOf('\n-Test ',n1pos)
                        if (n2pos < 0) n2pos = xxd.indexOf('\n--|>',n1pos)                        
                        this.testResults[i].expected = this.delChars(xxd.substring(n1pos+1,n2pos),'>','\n')
                    }
                }
            } else {
                if (data.indexOf('\nIncorrect program output') > -1) {
                    // console.log(data)    
                    var n1p = data.indexOf('<|--\n-Test ')
                    var n2p = data.indexOf(':',n1p)
                    let x_index = data.substring(n1p+11,n2p) - 1
                    this.testResults[x_index].test_result = 'failed'

                    // find --- Input
                    n1p = data.indexOf('\n',data.indexOf('--- Input'))
                    n2p = data.indexOf('\n --- Program output',n1p+1)
                    // 
                    this.testResults[x_index].input = this.delChars(data.substring(n1p+1,n2p),'>','\n')
                    // find --- Program output                        
                    n2p = data.indexOf('\n',n2p+1)
                    n1p = data.indexOf('\n --- Expected output',n2p+1)
                    // 
                    this.testResults[x_index].output = this.delChars(data.substring(n2p+1,n1p),'>','\n')
                    // find --- Expected output
                    n1p = data.indexOf('\n',n1p+1)
                    n2p = data.indexOf('\n-Test ',n1p)
                    if (n2p < 0) n2p = data.indexOf('\n--|>',n1p)                        
                    this.testResults[x_index].expected = this.delChars(data.substring(n1p+1,n2p),'>','\n')
                }
            }                       
        },
        delChars(data,f,l){
            var i = 0
            while (data.indexOf('\n>')>-1) {
                i = data.indexOf('\n>')
                data = data.substring(0,i+1) + data.substring(i+2)
            }
            data = data.substring(data.length-1) == l ? data.substring(0,data.length-1) : data
            return (data.substring(0,1) == f) ? data.substring(1) : data
        },

        }
    }
    </script>

